import { createElementBlock as i, openBlock as e, normalizeClass as c, createElementVNode as n, createCommentVNode as a, toDisplayString as d, createVNode as r, createBlock as s, unref as o } from "vue";
/* empty css                    */
import m from "../../_virtual/_plugin-vue_export-helper.js";
import l from "../../molecules/link/link.vue.js";
const u = { class: "ds-background-color-green ds-padding-y-48 ds-md-padding-y-96" }, y = { class: "custom-full-width" }, g = { class: "ds-container" }, k = { class: "ds-grid" }, p = { class: "ds-grid__col ds-grid__col--12 ds-md-grid__col--10 ds-lg-grid__col--8 ds-cta__columns" }, w = {
  class: "ds-heading",
  "data-j-title": ""
}, h = {
  key: 0,
  class: "ds-text ds-margin-top-12",
  "data-j-text": ""
}, x = { class: "ds-buttons-wrapper ds-margin-top-48" }, f = /* @__PURE__ */ Object.assign({
  name: "DsCallToAction"
}, {
  __name: "call-to-action",
  props: {
    /**
     * Call to action title
     */
    title: { type: String, required: !0 },
    /**
     * Call to action text, optional
     */
    text: { type: String, default: "" },
    /**
     * Call to action primary link
     * @property {string} primaryLink.title - link title
     * @property {string} primaryLink.url - link href value
     * @property {boolean} primaryLink.openInNewWindow - open the link in a new window
     * @property {boolean} primaryLink.nuxt - renders as nuxt link
     */
    primaryLink: { type: Object, required: !0 },
    /**
     * Call to action secondary link, optional
     * @property {string} secondaryLink.title - link title
     * @property {string} secondaryLink.url - link href value
     * @property {boolean} secondaryLink.openInNewWindow - open the link in a new window
     * @property {boolean} secondaryLink.nuxt - renders as nuxt link
     */
    secondaryLink: { type: Object, default: null },
    /**
     * Add padding top
     */
    withSpaceTop: { type: Boolean, default: !0 },
    /**
     * Add padding bottom
     */
    withSpaceBottom: { type: Boolean, default: !0 }
  },
  setup(t) {
    return (L, b) => (e(), i("section", {
      class: c(["ds-background-color-white ds-padding-x-12 ds-md-padding-x-24", {
        "ds-padding-top-12 ds-md-padding-top-24": t.withSpaceTop,
        "ds-padding-bottom-12 ds-md-padding-bottom-24": t.withSpaceBottom
      }])
    }, [
      n("div", u, [
        n("div", y, [
          n("div", g, [
            n("div", k, [
              n("div", p, [
                n("h2", w, d(t.title), 1),
                t.text ? (e(), i("p", h, d(t.text), 1)) : a("", !0),
                n("div", x, [
                  r(o(l), {
                    "data-j-primary-link": "",
                    "tracking-data": { "component-name": "DsCallToAction", text: t.primaryLink.title, title: t.title },
                    url: t.primaryLink.url,
                    "open-in-new-window": t.primaryLink.openInNewWindow,
                    "lazy-url-endpoint": t.primaryLink.lazyUrlEndpoint,
                    nuxt: t.primaryLink.nuxt,
                    content: t.primaryLink.title,
                    type: "button",
                    color: "black"
                  }, null, 8, ["tracking-data", "url", "open-in-new-window", "lazy-url-endpoint", "nuxt", "content"]),
                  t.secondaryLink ? (e(), s(o(l), {
                    key: 0,
                    "data-j-secondary-link": "",
                    "tracking-data": { "component-name": "DsCallToAction", text: t.secondaryLink.title, title: t.title },
                    url: t.secondaryLink.url,
                    "open-in-new-window": t.secondaryLink.openInNewWindow,
                    "lazy-url-endpoint": t.secondaryLink.lazyUrlEndpoint,
                    nuxt: t.secondaryLink.nuxt,
                    content: t.secondaryLink.title,
                    "icon-right": { category: "arrows", name: "chevron-right-small" },
                    color: "black",
                    class: "ds-margin-top-24 ds-md-margin-top-0 ds-md-margin-left-24"
                  }, null, 8, ["tracking-data", "url", "open-in-new-window", "lazy-url-endpoint", "nuxt", "content"])) : a("", !0)
                ])
              ])
            ])
          ])
        ])
      ])
    ], 2));
  }
}), S = /* @__PURE__ */ m(f, [["__scopeId", "data-v-e17f53f0"]]);
export {
  S as default
};
